import {TripCollection} from "../Trip";
import curtea from "../../../assets/child/curtea.jpg";

const dayChildCurtea: TripCollection = {
    imageSrc: curtea,
    trips: [
        {
            name: "11.1. Curtea de Argeş I",
            route: "Braşov – Dâmbovicioara – Curtea de Argeş – Braşov",
            days: [
                [
                    {
                        locationName: "Peştera Dâmbovicioara",
                    },
                    {
                        locationName: "Mausoleul Mateiaş",
                    },
                    {
                        locationName: "Mănăstirea Curtea de Argeş",
                    },
                ]
            ],
            notes: "Programul oferă o incursiune ce îmbină spectaculozitatea naturală cu repere istorice și spirituale ale României. Vizita la Peștera Dâmbovicioara introduce participanții într-un cadru natural impresionant, unde formațiunile calcaroase creează un peisaj subteran deosebit. Traseul continuă cu Mausoleul Mateiaș, monument comemorativ dedicat eroilor, care oferă un moment de reflecție asupra istoriei recente. Excursia se încheie la Mănăstirea Curtea de Argeș, unul dintre cele mai importante lăcașuri de cult din România, renumit pentru arhitectura sa și pentru legendele care îi învăluie istoria. Programul propune o experiență echilibrată, ce îmbină natura, istoria și spiritualitatea."
        },
        {
            name: "11.2. Curtea de Argeş II",
            route: "Braşov – Nămăieşti – Curtea de Argeş – Braşov",
            days: [
                [
                    {
                        locationName: "Mausoleul Mateiaş",
                    },
                    {
                        locationName: "Mănăstirea Nămăieşti",
                    },
                    {
                        locationName: "Mănăstirea Curtea de Argeş",
                    },
                ]
            ],
            notes: "Excursia propune o incursiune în istoria, spiritualitatea și cultura regiunii Argeșului, oferind momente de reflecție și descoperire. Prima oprire este la Mausoleul Mateiaș, monument dedicat eroilor, care impresionează prin solemnitate și încărcătură istorică. Traseul continuă la Mănăstirea Nămăiești, un lăcaș de cult plin de liniște și tradiție, iar experiența se încheie la Mănăstirea Curtea de Argeș, celebră pentru arhitectura sa impresionantă și legendele care îi învăluie istoria. Excursia oferă o zi echilibrată, în care natura, istoria și spiritualitatea se împletesc armonios."
        },
        {
            name: "11.3. Curtea de Argeş III",
            route: "Braşov – Curtea de Argeş – Braşov",
            days: [
                [
                    {
                        locationName: "Mausoleul Mateiaş",
                    },
                    {
                        locationName: "Mănăstirea Curtea de Argeş",
                    },
                    {
                        locationName: "Fabrica de Globuri",
                    },
                ]
            ],
            notes: "Programul propune o zi plină de descoperiri culturale, istorice și tradiționale. Vizita începe la Mausoleul Mateiaș, monument dedicat eroilor, care impresionează prin solemnitate și valoare istorică. Traseul continuă la Mănăstirea Curtea de Argeș, celebră pentru arhitectura sa impresionantă și poveștile care învăluie istoria sa, oferind un cadru de liniște și reflecție. Excursia se încheie la Fabrica de Globuri, unde vizitatorii descoperă meșteșugul și tradițiile realizării globurilor decorative, creând o experiență completă, ce îmbină cultura, istoria și tradiția."
        },
    ]
}

export default dayChildCurtea;